
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AppVersion extends Vue {
  get appVersion(): string {
    return (process.env.VUE_APP_COMMIT_HASH as string).slice(0, 5);
  }
}
